import { useResponsiveValue } from 'braid-design-system';
import { Fragment, type ReactNode } from 'react';

import { useEffectOnce } from 'src/hooks/useEffectOnce';
import { segment } from 'src/utils/segment';

interface SegmentAnalyticsProps {
  children: ReactNode;
  pageTitle: string;
}

const SegmentAnalytics = ({ children, pageTitle }: SegmentAnalyticsProps) => {
  const responsiveValue = useResponsiveValue();

  const isMobile = responsiveValue({
    mobile: true,
    tablet: false,
  });

  useEffectOnce(() => {
    // This has to be defined in here as "window" is available only at client side
    const urlParams = new URLSearchParams(window.location.search);
    const utm_campaign = urlParams.get('utm_campaign');
    const utm_content = urlParams.get('utm_content');
    const utm_medium = urlParams.get('utm_medium');
    const utm_term = urlParams.get('utm_term');
    const utm_source = urlParams.get('utm_source');
    const common_props = {
      brand: 'seek_business',
      channel: 'web',
      current_page: window.location.href.split('?')[0],
      experience: 'business',
      page_domain: window.location.origin,
      page_pathname: window.location.pathname,
      ...(window.location.search.length > 0 && {
        page_query_string: window.location.search.substring(1),
      }),
      page_title: pageTitle,
      page_url: window.location.href,
      platform: isMobile ? 'mobile web' : 'desktop web',
      site_country: 'au',
      site_language: 'en',
      ...(utm_campaign && { utm_campaign }),
      ...(utm_content && { utm_content }),
      ...(utm_medium && { utm_medium }),
      ...(utm_term && { utm_term }),
      ...(utm_source && { utm_source }),
      zone: 'anz-1',
      tracking_version: 1,
    };
    const cdp_event_name = `skbau_${pageTitle}_viewed`;

    segment.track('Page Viewed', {
      ...common_props,
      cdp_event_name,
    });
  });

  return <Fragment>{children}</Fragment>;
};

export default SegmentAnalytics;
